import { render, staticRenderFns } from "./ExpandTable.vue?vue&type=template&id=799531d9&scoped=true&"
import script from "./ExpandTable.vue?vue&type=script&lang=js&"
export * from "./ExpandTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpandTable.vue?vue&type=style&index=0&id=799531d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799531d9",
  null
  
)

export default component.exports